module.exports = __webpack_public_path__ + "img/instructions.60b9ef01.svg";